const getTransactionID = (transactionID: string) => ({
  transaction_id: transactionID,
});

export default getTransactionID;
